import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FeaturesService } from "../features.service";
import { MetaService } from "../meta.service";

@Component({
	selector: "pricing-features",
	encapsulation: ViewEncapsulation.None,
	templateUrl: "./pricing-features.component.html",
	styleUrls: ["./pricing-features.component.css"],
})
export class PricingFeaturesComponent implements OnInit {
	//private catalogs
	features: any[] = [];

	//inject services
	constructor(private mds: MetaService, private fts: FeaturesService) {}

	//initialize the component
	ngOnInit(): void {
		//get features
		this.features = this.fts.getFeatures();

		//SEO Optimization
		var strTitle = "RegScale";
		var description =
			"Continuous Compliance Automation Platform for Highly Regulated Industries";
		var keywords =
			"RegScale, SMB, Small, Medium, Business, CMMC, compliance, cyber security, audits, cost savings, issues management, vendor management";
		this.mds.updateTags(strTitle, keywords, description);
	}
}
